import { toast } from 'vue3-toastify'

const defaultOptions = {
    position: toast.POSITION.TOP_CENTER,
    autoClose: 4000,
    toastStyle: {
        width: '520px',
        maxWidth: '90vw'
    }
}

export function useToast() {
    return {
        success: (msg, opts = {}) => toast.success(msg, { ...defaultOptions, ...opts }),

        error: (msg, opts = {}) => toast.error(msg, { ...defaultOptions, ...opts }),

        warning: (msg, opts = {}) => toast.warning(msg, { ...defaultOptions, ...opts }),

        info: (msg, opts = {}) => toast(msg, { ...defaultOptions, ...opts })
    }
}
